// ThemePalettePicker — اختيار مجموعة ألوان النظام (الهوية) من الإعدادات العامة.
// يعرض المجموعات كبطاقات swatch (كاللوحة المرجعية)، ويحفظ الاختيار ويُطبّقه
// على كامل الواجهة بإعادة تحميل خفيفة. (3.4.0 — نظام هويات متعدّد)
import React, { useState } from 'react';
import { Box, Card, CardActionArea, Chip, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTranslation } from 'react-i18next';
import {
  THEME_PALETTES, DEFAULT_PALETTE, getActivePaletteKey, setActivePaletteKey,
  SMART_COLORS as C,
} from '../theme/smartStableTheme';

export default function ThemePalettePicker() {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === 'ar';
  const [selected, setSelected] = useState(getActivePaletteKey());

  const choose = (key) => {
    if (key === getActivePaletteKey()) return;
    setSelected(key);
    setActivePaletteKey(key);
    // تُحلّ الألوان عند تحميل الوحدة، فنطبّق الهوية الجديدة بإعادة تحميل.
    window.location.reload();
  };

  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5, flexWrap: 'wrap' }}>
        <Typography sx={{ fontWeight: 900, color: C.text }}>{t('theme.title', 'مجموعة ألوان النظام')}</Typography>
        <Chip size="small" label={t('saved_instantly', 'يُحفظ فورًا')} sx={{ bgcolor: C.greenSoft, color: C.green, fontWeight: 800, height: 22 }} />
      </Stack>
      <Typography variant="body2" sx={{ color: C.muted, mb: 2 }}>
        {t('theme.hint', 'اختر هوية الألوان. تُطبَّق على كامل الواجهة وتُحفظ في هذا المتصفّح.')}
      </Typography>
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        {Object.values(THEME_PALETTES).map((p) => {
          const isActive = selected === p.key;
          return (
            <Card key={p.key} variant="outlined"
              sx={{ width: 230, borderColor: isActive ? C.gold : C.line, borderWidth: isActive ? 2 : 1 }}>
              <CardActionArea onClick={() => choose(p.key)} sx={{ p: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                  <Typography sx={{ fontWeight: 800, color: C.text }}>{isAr ? p.name_ar : p.name_en}</Typography>
                  {isActive && <CheckCircleIcon sx={{ color: C.gold }} />}
                </Stack>
                <Stack direction="row" sx={{ borderRadius: 1, overflow: 'hidden', border: `1px solid ${C.line}` }}>
                  {p.swatch.map((c, i) => <Box key={i} sx={{ flex: 1, height: 40, bgcolor: c }} />)}
                </Stack>
                {p.key === DEFAULT_PALETTE && (
                  <Chip size="small" label={t('theme.default', 'افتراضي')} sx={{ mt: 1, bgcolor: C.goldSoft, fontWeight: 700 }} />
                )}
              </CardActionArea>
            </Card>
          );
        })}
      </Stack>
    </Box>
  );
}
